import { Link } from "react-router-dom";
import {
  DieuDuongSVG,
  DuocVatTuSVG,
  GlassSVG,
  KhamBenhSVG,
  KhucXaSVG,
  PaySVG,
  SettingSVG,
  TiepNhanSVG,
  XetNghiemSVG,
  ChanDoanSvg,
  CustomerCareSVG,
  CSKHSvg,
  NoiTruSVG,
  DienTimSVG,
  PartnerExchange,
  Calculate,
  ServicePackageSVG,
  UploadSVG,
  UploadXmlSVG,
  AccoutingFinacialSVG,
  DocumentSVG,
  SearchSVG,
  ShoppingSVG,
} from "assets/images";
import React from "react";
import SiderIcon from "components/common/SiderIcon/SiderIcon";
const routes = [
  {
    label: "Tiếp nhận",
    link: "/tiep-nhan/",
    key: "tiep-nhan",
  },
  { label: "Thanh toán", key: "thanh-toan", link: "/thanh-toan/thanh-toan" },
  {},
];
const menus: any[] = [
  {
    label: "Tiếp nhận",
    link: "/tiep-nhan/",
    key: "tiepNhan",
    icon: <TiepNhanSVG></TiepNhanSVG>,
  },
  {
    label: "Thanh toán",
    key: "thanhToan",
    link: "/thanh-toan/thanh-toan",
    icon: <PaySVG></PaySVG>,
  },
  {
    label: "Dữ liệu XML",
    // link: "/thanh-toan",
    icon: <UploadXmlSVG></UploadXmlSVG>,
    subItems: [
      {
        key: "dayDuLieuXml",
        label: "Đẩy dữ liệu XML",
        link: "/thanh-toan/day-du-lieu-xml",
        roles: ["xml"],
      },

      {
        key: "ketXuatXml",
        label: "Kết xuất XML",
        link: "/thanh-toan/ket-xuat-xml",
        roles: ["xml"],
      },
    ],
    roles: ["xml"],
  },
  {
    label: "Khúc xạ",
    link: "/khuc-xa",
    key: "khucXa",
    icon: <KhucXaSVG></KhucXaSVG>,
    roles: ["khuc_xa"],
  },
  {
    label: "Điều dưỡng ngoại trú",
    link: "/dieu-duong/ngoai-tru",
    key: "dieuDuongNgoaiTru",
    icon: <DieuDuongSVG></DieuDuongSVG>,
    roles: ["dd_ngoai_tru"],
  },

  {
    label: "Khám bệnh ngoại trú",
    key: "khamBenh",
    link: "/kham-benh",
    icon: <KhamBenhSVG></KhamBenhSVG>,
    roles: ["kham_benh_ngoai_tru"],
  },
  {
    label: "Xét Nghiệm",
    link: "/xet-nghiem",
    key: "xetNghiem",
    icon: <XetNghiemSVG></XetNghiemSVG>,
    roles: ["xet_nghiem"],
  },
  {
    label: "Chẩn đoán hình ảnh",
    key: "chanDoan",
    link: "/chan-doan-hinh-anh",
    icon: <ChanDoanSvg />,
    roles: ["cdha"],
  },
  {
    label: "Điện tim",
    key: "dienTim",
    link: "/dien-tim",
    icon: <DienTimSVG />,
    roles: ["dien_tim"],
  },
  {
    label: "Điều trị nội trú",
    key: "dieuTriNoiTru",
    icon: <NoiTruSVG></NoiTruSVG>,
    subItems: [
      {
        key: "dieuDuongNoiTru",
        label: "Điều dưỡng nội trú",
        link: "/dieu-tri-noi-tru/dieu-duong-noi-tru",
        roles: ["dd_noi_tru", "dieu_tri_noi_tru"],
      },
      {
        key: "dieuTri",
        label: "Điều trị",
        link: "/dieu-tri-noi-tru/dieu-tri",
        roles: ["dieu_tri", "dieu_tri_noi_tru"],
      },

      {
        key: "phauThuat",
        label: "Phẫu thuật",
        link: "/dieu-tri-noi-tru/phau-thuat",
        roles: ["phau_thuat", "dieu_tri_noi_tru"],
      },
    ],
    roles: ["dieu_tri_noi_tru", "dd_noi_tru", "dieu_tri", "phau_thuat"],
  },
  {
    label: "Tư vấn và CSKH",
    key: "tuVanDieuTri",
    icon: <CSKHSvg />,
    subItems: [
      {
        key: "tuVanDieuTri",
        label: "Tư vấn điều trị ",
        link: "/cs-khach-hang/tu-van-dieu-tri",
        roles: ["tu_van_cskh", "tu_van_dieu_tri"],
      },
      {
        key: "cskh",
        label: "Chăm sóc khách hàng",
        link: "/cs-khach-hang/cham-soc-khach-hang",
        roles: ["tu_van_cskh", "cskh"],
      },
    ],
    roles: ["tu_van_cskh", "tu_van_dieu_tri", "cskh"],
  },
  {
    label: "Quản lý dịch vụ",
    icon: <ServicePackageSVG />,
    subItems: [
      {
        key: "dichVuKiThuat",
        label: "Dịch vụ kỹ thuật",
        link: "/quan-ly-dich-vu/dich-vu-ky-thuat",
        roles: ["quan_dich_vu"],
      },
      {
        key: "goiDichVu",
        label: "Gói dịch vụ",
        link: "/quan-ly-dich-vu/goi-dich-vu",
        roles: ["quan_dich_vu"],
      },
      {
        key: "theKham",
        label: "Thẻ khám và chương trình ưu đãi",
        link: "/cs-khach-hang/the-kham-va-chuong-trinh-uu-dai",
        roles: ["tu_van_cskh", "the_kham_chuong_trinh"],
      },
    ],
    roles: ["quan_dich_vu", "the_kham_chuong_trinh"],
  },
  {
    label: "Dược và vật tư",
    icon: (
      <DuocVatTuSVG
        style={{ height: 18, width: 18, marginBottom: 8 }}
      ></DuocVatTuSVG>
    ),
    key: "thuoc-vat-tu",
    subItems: [
      {
        key: "nhaThuoc",
        label: "Nhà thuốc",
        link: "/duoc-vat-tu/nha-thuoc",
        roles: ["duoc_vat_tu", "nha_thuoc"],
      },
      {
        key: "khoDuoc",
        label: "Kho dược",
        link: "/duoc-vat-tu/kho-duoc",
        roles: ["duoc_vat_tu", "kho_duoc"],
      },
      {
        key: "khoVatTu",
        label: "Kho vật tư y tế",
        link: "/duoc-vat-tu/kho-vat-tu-y-te",
        roles: ["duoc_vat_tu", "kho_vtyt"],
      },
    ],
    roles: ["duoc_vat_tu", "nha_thuoc", "kho_duoc", "kho_vtyt"],
  },

  {
    label: "Kính",
    icon: <GlassSVG />,
    subItems: [
      {
        key: "quayKinh",
        label: "Quầy kính",
        link: "/kinh/quay-kinh",
        roles: ["quan_ly", "quan_ly_kho_kinh", "kk_ban_kinh", "kk_in"],
      },
      {
        key: "khoKinh",
        label: "Kho kính",
        link: "/kinh/kho-kinh",
        roles: [
          "quan_ly",
          "quan_ly_kho_kinh",
          "kk_nhap_ncc",
          "kk_nhap",
          "kk_xuat",
          "kk_i",
        ],
      },
    ],
    roles: [
      "quan_ly",
      "quan_ly_kho_kinh",
      "kk_nhap_ncc",
      "kk_nhap",
      "kk_xuat",
      "kk_i",
      "kk_in",
      "kk_ban_kinh",
    ],
  },
  {
    label: "Quản lý nhân sự",
    icon: <PartnerExchange />,
    subItems: [
      {
        key: "nhanVien",
        label: "Danh sách nhân viên",
        link: "/quan-ly-nhan-su/danh-sach-nhan-vien",
        roles: ["quan_ly_nhan_su"],
      },
      // {
      //   key: "khen-thuong",
      //   label: "Khen thưởng",
      //   link: "/quan-ly-nhan-su/khen-thuong",
      // },
      {
        key: "kyLuat",
        label: "Kỷ luật",
        link: "/quan-ly-nhan-su/ky-luat",
      },
      {
        key: "congChuan",
        label: "Công chuẩn tháng",
        link: "/quan-ly-nhan-su/cong-chuan-thang",
        roles: ["quan_ly_nhan_su"],
      },
      {
        key: "tuyenDung",
        label: "Đợt tuyển dụng",
        link: "/quan-ly-nhan-su/dot-tuyen-dung",
        roles: ["quan_ly_nhan_su"],
      },
      {
        key: "ungVien",
        label: "Danh mục ứng viên",
        link: "/quan-ly-nhan-su/danh-muc-ung-vien",
        roles: ["quan_ly_nhan_su"],
      },
      {
        key: "khoaDaoTao",
        label: "Khóa đào tạo",
        link: "/quan-ly-nhan-su/khoa-dao-tao",
        roles: ["quan_ly_nhan_su"],
      },
    ],
    roles: ["quan_ly_nhan_su"],
  },
  {
    label: "Tính lương",
    icon: <Calculate />,
    key: "tinh-luong",
    subItems: [
      {
        key: "caLamViec",
        label: "Ca làm việc",
        link: "/tinh-luong/ca-lam-viec",
        roles: ["tinh_luong"],
      },
      {
        key: "chamCongTho",
        label: "Chấm công thô",
        link: "/tinh-luong/cham-cong-tho",
        roles: ["tinh_luong"],
      },
      {
        key: "chamCong",
        label: "Chấm công",
        link: "/tinh-luong/cham-cong",
        roles: ["tinh_luong"],
      },
      {
        key: "theoDoiNghiBu",
        label: "Theo dõi nghỉ bù",
        link: "/tinh-luong/theo-doi-nghi-bu",
        roles: ["tinh_luong"],
      },
      {
        key: "theoDoiDiMuon",
        label: "Theo dõi đi muộn",
        link: "/tinh-luong/theo-doi-di-muon",
        roles: ["tinh_luong"],
      },
      {
        key: "nghiPhep",
        label: "Đăng ký nghỉ phép",
        link: "/tinh-luong/dang-ky-nghi-phep",
        roles: ["tinh_luong"],
      },
      {
        key: "lamThem",
        label: "Chấm công làm thêm giờ",
        link: "/tinh-luong/cham-cong-lam-them-gio",
        roles: ["tinh_luong"],
      },
      {
        key: "bangLuong",
        label: "Bảng lương",
        link: "/tinh-luong/bang-luong",
        roles: ["tinh_luong"],
      },
      {
        key: "bhxh",
        label: "Theo dõi BHXH",
        link: "/tinh-luong/theo-doi-bhxh",
        roles: ["tinh_luong"],
      },
      {
        key: "caiDatLuong",
        label: "Cài đặt lương",
        link: "/tinh-luong/cai-dat-luong",
        roles: ["tinh_luong"],
      },
      {
        key: "thue",
        label: "Biểu thuế TNCN",
        link: "/tinh-luong/bieu-thue",
        roles: ["tinh_luong"],
      },
      {
        key: "duyetBangLuong",
        label: "Duyệt bảng lương",
        link: "/tinh-luong/duyet-bang-luong",
        roles: ["tinh_luong"],
      },
      {
        key: "danhMucTrangThaiDuyet",
        label: "Danh mục trạng thái duyệt",
        link: "/tinh-luong/danh-muc-trang-thai-duyet",
        roles: ["tinh_luong"],
      },
      {
        key: "khaiBaoQuyenDuyet",
        label: "Khai báo quyền duyệt",
        link: "/tinh-luong/khai-bao-quyen-duyet",
        roles: ["tinh_luong"],
      },
      {
        key: "khaiBaoNguoiDuyet",
        label: "Khai báo người duyệt",
        link: "/tinh-luong/khai-bao-nguoi-duyet",
        roles: ["tinh_luong"],
      },
    ],
    roles: ["tinh_luong"],
  },
  {
    label: "Quản lý văn bản",
    link: "/quan-ly-van-ban/",
    key: "vanBan",
    icon: <DocumentSVG />,
    // roles: ["tiep_nhan"],

    // subItems: [
    //   {
    //     key: "quan-ly-van-ban",
    //     label: "Quản lý văn bản",

    //     roles: ["quan_ly_van_ban"],
    //   },
    // ],

    roles: ["quan_ly_van_ban"],
  },
  {
    label: "Tài chính kế toán",
    icon: <AccoutingFinacialSVG />,
    subItems: [
      {
        key: "baoCaoDoanhThu",
        label: "Báo cáo doanh thu",
        link: "/tai-chinh-ke-toan/bao-cao-doanh-thu",
        roles: ["tai_chinh_ke_toan"],
      },
      {
        key: "baoCaoKho",
        label: "Báo cáo kho",
        link: "/tai-chinh-ke-toan/bao-cao-kho",
        roles: ["tai_chinh_ke_toan"],
      },
      {
        key: "baoCaoTongHop",
        label: "Báo cáo tổng hợp",
        link: "/tai-chinh-ke-toan/bao-cao-tong-hop",
        roles: ["tai_chinh_ke_toan"],
      },
    ],
    roles: ["tai_chinh_ke_toan"],
  },
  {
    label: "Quản lý mua sắm",
    icon: <ShoppingSVG />,
    subItems: [
      {
        key: "deNghiMuaSam",
        label: "Đề nghị mua sắm",
        link: "/quan-ly-mua-sam/mua-sam",
      },
      {
        key: "deNghiThanhToan",
        label: "Đề nghị thanh toán",
        link: "/quan-ly-mua-sam/thanh-toan",
      },
    ],
    roles: ["tai_chinh_ke_toan"],
  },
  {
    label: "Thông tin BN cũ",
    link: "/benh-nhan-cu",
    key: "benhNhanCu",
    icon: <SearchSVG></SearchSVG>,
  },

  {
    key: "phanQuyen",
    label: "Phân quyền",
    icon: <SettingSVG />,
    link: "/he-thong/phan-quyen",
    // subItems: [
    //   {
    //     key: "phanQuyen",
    //     label: "Phân quyền",

    //     link: "/he-thong/phan-quyen",
    //     roles: ["quan_ly_he_thong"],
    //   },
    //   // {
    //   //   key: "danhMucChung",
    //   //   label: "Danh mục dùng chung",
    //   //   link: "/he-thong/danh-muc-chung",
    //   //   roles: ["quan_ly_he_thong"],
    //   // },
    // ],
  },

  // {
  //   label: "Trang mẫu",
  //   icon: <DieuDuongSVG></DieuDuongSVG>,
  //   link: "/trang-mau",
  // },
  {
    key: "kyBaoMat",
    label: "Kí bảo mật",
    icon: <TiepNhanSVG></TiepNhanSVG>,
    link: "/ki-bao-mat",
  },
];
const siderData: any[] = [];
const pushSiderData = (menus, siderData) => {
  menus.forEach((menuItem, index) => {
    siderData.push({
      key: menuItem.key,
      icon: menuItem.icon,
      label: menuItem.link ? (
        <Link className="link-menu" to={`${menuItem.link}`}>
          {menuItem.label}
        </Link>
      ) : (
        <div>{menuItem.label}</div>
      ),
      children: menuItem.subItems?.map((subItem, index) => {
        return {
          className: "sub-menu",
          key: subItem.key,
          icon: subItem.icon,
          label: (
            <Link className="link-submenu" to={`${subItem.link}`}>
              {subItem.label}
            </Link>
          ),
        };
      }),
    });
  });
};
pushSiderData(menus, siderData);
export { siderData, menus, pushSiderData };
